import { useCookies } from "react-cookie";

export default function useGetRole() {
    const [cookies] = useCookies();
    const { isAuthorized, role } = cookies;

    const isAdmin = role === "admin";
    return { isAdmin, isAuthorized };
}
